export type KeyboardDifficulty = 'adaptive' | 'challenging' | 'full';

export interface AppConfig {
  debug: {
    showDebugButton: boolean;
    logQuota: number;
    serverUrl?: string;
  };
  ui: {
    showKeyboardHints: boolean;
    showFullWordDisplay: boolean;
    showVirtualKeyboard: boolean;
    keyboardDifficulty: KeyboardDifficulty;
  };
  game: {
    fullConversationMode: boolean;
  };
}

export const defaultConfig: AppConfig = {
  debug: {
    showDebugButton: true,
    logQuota: 5000,
    serverUrl: '/api/save-logs'
  },
  ui: {
    showKeyboardHints: false,
    showFullWordDisplay: true,
    showVirtualKeyboard: true,
    keyboardDifficulty: 'full'
  },
  game: {
    fullConversationMode: false
  }
};

let currentConfig: AppConfig = { ...defaultConfig };

export const getConfig = (): AppConfig => {
  return currentConfig;
};

export const updateConfig = (newConfig: Partial<AppConfig>): void => {
  currentConfig = {
    ...currentConfig,
    ...newConfig,
    debug: { ...currentConfig.debug, ...newConfig.debug },
    ui: { ...currentConfig.ui, ...newConfig.ui },
    game: { ...currentConfig.game, ...newConfig.game }
  };
};